module.exports = __webpack_public_path__ + "bef41f9dd4c8739fce86f231b9bd831f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero-img.png
// module id = 761
// module chunks = 2